import { Component, Input, OnInit } from '@angular/core';

export enum Size {
  XXS = 'xxs',
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
  XXL = 'xxl',
  Plan = 'plan'
}

@Component({
  selector: 'app-pointer',
  templateUrl: './pointer.component.html',
  styleUrls: ['./pointer.component.scss']
})
export class PointerComponent implements OnInit {
  Size = Size;

  @Input() size: Size = Size.M;
  @Input() name: string;

  constructor() { }

  ngOnInit(): void {
  }

}
